import { Box, Button, Container, Grid, Icon, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { ApiErrorResponse } from '../common/types';

import logoImage from '../assets/gg-black.svg';
import errorImage from '../assets/gg__illustration--No-Search-Results-Found.svg';

interface GeneralErrorPageProps {
  error: ApiErrorResponse;
}

function GeneralErrorPage({ error }: GeneralErrorPageProps) {
  const { code, message, details } = error.error;

  return (
    <Box
      component="main"
      id="main-content"
      role="main"
      sx={{
        flexGrow: 1,
        display: 'flex',
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="lg">
        <Grid container>
          <Grid size={12}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: 5,
                mb: 5,
              }}
            >
              <Typography
                sx={{ mb: 5 }}
                variant="h6"
                noWrap
                component={Link}
                to="/"
              >
                <Icon
                  sx={{
                    display: 'flex',
                    mr: 1,
                    height: '40px',
                    width: '160px',
                  }}
                >
                  <img src={logoImage} alt="Grant Guardian logo" />
                </Icon>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={{ xs: 12, md: 4 }} sx={{ ml: { md: '16.666667%' } }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                mb: 5,
                gap: 1,
              }}
            >
              <Typography variant="h2">{code}</Typography>
              <Typography variant="h4">Our apologies!</Typography>
              <Typography variant="h6">{message}</Typography>
            </Box>
            {details && (
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body1">
                  <strong>Details</strong>
                </Typography>
                <Box component="ul" sx={{ mt: 2, mb: 5, pl: 2 }}>
                  <Box component="li" sx={{ mt: 2 }}>
                    {details}
                  </Box>
                </Box>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 3 }}>
              <Button
                component={Link}
                variant="contained"
                color="secondary"
                to="/"
              >
                Grant Guardian Home
              </Button>
              <Button
                component={Link}
                variant="outlined"
                color="secondary"
                to="/help"
              >
                Help center
              </Button>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Box
              component="figure"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 0,
              }}
            >
              <img src={errorImage} alt={`${code} error illustration`} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default GeneralErrorPage;
